import axios from "./axios"

/**
 * 查詢文件類型
 * @param {*} serviceType  
 */
const get = (serviceType, ) => {
    return axios.get(`/public/api/v1/document-type?serviceType=${serviceType}`).then(res => res.data)
}

export default {
    get
}